import React, { forwardRef } from "react";

// import images
import Logo from "../assets/Logo.png";
import Avatar from "../assets/avatar.png";
// import utils
import { Link, useNavigate } from "react-router-dom";
import { icon } from "../utils/icons";

// import component
import DropDown from "./DropDown";
import { Heading } from "@chakra-ui/react";
import DImage from "./DImage";
import DButton from "./DButton";
import { setCookie } from "../utils/functions";
import authServices from "../services/auth";
import { useDispatch, useSelector } from "react-redux";
import { setAuth } from "../redux/slicers/config";
const Navbar = forwardRef(({ sidebarHandler }, ref) => {
    const navigate = useNavigate(); // navigate for another page
    const dispatch = useDispatch();
    const { auth } = useSelector(state => state.config);
    const logoutHandler = () => {
        authServices.logout();
        setCookie("dc-auth", "", -1);
        dispatch(setAuth({}));
        navigate("/login", { replace: true });
    };
    const menuItems = [
        {
            id: 1,
            name: (
                <p className="flex items-center">
                    <span className="me-1">{icon.user}</span>
                    البروفايل
                </p>
            ),
            clickHandler: () => navigate("/profile"),
        },

        {
            id: 2,
            name: (
                <p className="flex items-center">
                    <span className="me-1">{icon.logout}</span>
                    تسجيل الخروج
                </p>
            ),
            clickHandler: logoutHandler,
        },
    ];

    return (
        <div
            ref={ref}
            className="text-primary-color-500 navbar  flex items-center shadow justify-between p-1 px-4 bg-white"
        >
            <Link to={"/"}>
                <DImage src={Logo} alt="logo" className="w-[90px]" />
            </Link>
            <div className="flex items-center">
                <DropDown
                    items={menuItems}
                    title={auth.username}
                    action={
                        <div className="avatar flex items-center">
                            <DImage
                                src={Avatar}
                                alt="avatar"
                                className="w-[30px] md:w-[40px] me-2  rounded-full bg-body-color"
                            />
                            <Heading
                                className="hidden lg:block"
                                as="h2"
                                size={["xs", "sm"]}
                            >
                                {auth.username}
                            </Heading>
                        </div>
                    }
                />
                <DButton
                    onClick={sidebarHandler}
                    varient="transparent"
                    className="block text-2xl lg:hidden"
                >
                    {icon.menu}
                </DButton>
            </div>
        </div>
    );
});

export default Navbar;
